<template>
    <div class="tooltip">
        <slot>
            <span class="tooltip-title">{{title}}</span>
            <a :href="link" v-if="link" v-html="text" target="_blank"></a>
            <p v-else v-html="text"></p>
        </slot>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        },
        link: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.tooltip
    z-index 2000
    position absolute
    bottom calc(100% - 32px)
    right 16px
    width 256px
    display flex
    flex-direction column
    flex 1 1 auto
    background-color $color-primary
    color $color-primary-text
    border-radius 5px
    border 1px solid #61D9FF
    padding 16px
    padding-bottom 32px
    box-sizing border-box
    // box-shadow 0 36px 24px -32px rgba(0, 0, 0, 0.4)
    box-shadow 0 42px 18px -28px rgba(0, 0, 0, 0.25)

    &.tooltip-left
        left 16px

    .tooltip-title
        font-size 12px
        text-transform uppercase
        color alpha(white, 60%)
        margin 0 !important
        margin-bottom 16px !important
        font-weight 400

    p
        font-size 14px
        margin 0
        font-weight 700

    b
        text-decoration underline

    a
        color $color-primary-text

</style>



// WEBPACK FOOTER //
// src/components/v3/tooltips/Tooltip.vue